import React, { useState, useEffect } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import "./nav.css";
import althiLogo from "../../Media/althilogo.svg";
import { GoGrabber, GoX } from "react-icons/go";
import { useLocation, Link } from "react-router-dom";
import banner1 from "../../Assets/WhatWeDo/portrait-indigenous-person-integrating-society-short.webp";
import banner2 from "../../Assets/WhatWeDo/business-person-futuristic-business-environment-short.webp";
import banner3 from "../../Assets/WhatWeDo/business-person-futuristic-business-environment-acaia-short.webp";

import webDevelopmentHeroImage from "../../Assets/Services/webDevelopment_hero_img.jpeg";
import careerBlackBackground from "../../Assets/Career/blackimage.webp";
import careerHolographicBackground from "../../Assets/Career/lavender-image.webp";
import careerJetImage from "../../Assets/Career/jetImage.webp";
import contactUsHeroImage from "../../Media/abstract-green-background.webp";
import blogBannerImage from "../../Assets/Blog/old-woman-working-home-office-illustration.webp";
gsap.registerPlugin(ScrollTrigger);

const preloadImage = (src) => {
  const img = new Image();

  img.src = src;
  img.fetchPriority = "high";
  img.decoding = "async";
};

const preloadBlog = () => {
  preloadImage(blogBannerImage);
};

const preloadProductImages = () => {
  [banner1, banner2, banner3].forEach(preloadImage);
};

const preloadWebDevelopment = () => {
  preloadImage(webDevelopmentHeroImage);
};

const preloadCareerImages = () => {
  [careerBlackBackground, careerHolographicBackground, careerJetImage].forEach(
    preloadImage,
  );
};

const preloadContactUs = () => {
  preloadImage(contactUsHeroImage);
};

const Nav = () => {
  const location = useLocation();

  const [productsOpen, setProductsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    let trigger;

    if (location.pathname === "/") {
      trigger = ScrollTrigger.create({
        trigger: ".hero",
        start: "bottom top",
        onEnterBack: () => {
          document.querySelector(".navbar")?.classList.remove("navbar-dark");
        },

        onLeave: () => {
          document.querySelector(".navbar")?.classList.add("navbar-dark");
        },
      });
    } else {
      document.querySelector(".navbar")?.classList.add("navbar-dark");
    }

    return () => {
      if (trigger) {
        trigger.kill();
      }
    };
  }, [location.pathname]);

  useEffect(() => {
    document.body.style.overflow = mobileMenuOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileMenuOpen]);

  return (
    <div className="container-navbar">
      <header
        className={`navbar ${mobileMenuOpen ? "navbar-mobile-active" : ""}`}
      >
        <div className="logo">
          <Link to="/">
            <img src={althiLogo} alt="Althi Solutions logo" />
          </Link>
        </div>

        <nav className="navlinks">
          <div
            className="nav-item"
            onMouseEnter={() => {
              preloadProductImages();
              setProductsOpen(true);
            }}
            onMouseLeave={() => {
              setProductsOpen(false);
            }}
          >
            <a href="/#" onClick={(e) => e.preventDefault()}>
              Products
            </a>

            {productsOpen && (
              <div className="dropdown">
                <Link
                  to="/whatWeDo/VCheck"
                  onPointerEnter={preloadProductImages}
                >
                  Vcheck
                </Link>

                <Link
                  to="/whatWeDo/Acaia"
                  onPointerEnter={preloadProductImages}
                >
                  Acaia
                </Link>

                <Link
                  to="/whatWeDo/Exaan"
                  onPointerEnter={preloadProductImages}
                >
                  Exaan
                </Link>

                <Link
                  to="/whatWeDo/Enrol"
                  onPointerEnter={preloadProductImages}
                >
                  Enrol-Admission Software
                </Link>
              </div>
            )}
          </div>

          <div
            className="nav-item"
            onMouseEnter={() => {
              setServicesOpen(true);
            }}
            onMouseLeave={() => {
              setServicesOpen(false);
            }}
          >
            <a href="#" onClick={(e) => e.preventDefault()}>
              Services
            </a>

            {servicesOpen && (
              <div className="dropdown">
                <Link
                  to="/contactus"
                  onPointerEnter={preloadContactUs}
                  onPointerDown={preloadContactUs}
                  onFocus={preloadContactUs}
                >
                  Software Development
                </Link>

                <Link
                  to="/contactus"
                  onPointerEnter={preloadContactUs}
                  onPointerDown={preloadContactUs}
                  onFocus={preloadContactUs}
                >
                  Product & Customer Support
                </Link>

                <Link
                  to="/services/web-development"
                  onPointerEnter={preloadWebDevelopment}
                  onPointerDown={preloadWebDevelopment}
                  onFocus={preloadWebDevelopment}
                >
                  Web Development
                </Link>

                <Link
                  to="/contactus"
                  onPointerEnter={preloadContactUs}
                  onPointerDown={preloadContactUs}
                  onFocus={preloadContactUs}
                >
                  AI & Data Science
                </Link>

                <Link
                  to="/contactus"
                  onPointerEnter={preloadContactUs}
                  onPointerDown={preloadContactUs}
                  onFocus={preloadContactUs}
                >
                  Mobile App Development
                </Link>

                <Link
                  to="/contactus"
                  onPointerEnter={preloadContactUs}
                  onPointerDown={preloadContactUs}
                  onFocus={preloadContactUs}
                >
                  Digital Marketing
                </Link>

                <Link
                  to="/contactus"
                  onPointerEnter={preloadContactUs}
                  onPointerDown={preloadContactUs}
                  onFocus={preloadContactUs}
                >
                  Resource to hire
                </Link>
              </div>
            )}
          </div>

          <Link to="/whoWeAre">Who we are</Link>

          <Link
            to="/blog"
            onPointerEnter={preloadBlog}
            onPointerDown={preloadBlog}
            onFocus={preloadBlog}
          >
            Insights
          </Link>

          <Link
            to="/careers"
            onPointerEnter={preloadCareerImages}
            onPointerDown={preloadCareerImages}
            onFocus={preloadCareerImages}
          >
            Careers
          </Link>

          <Link
            to="/contactus"
            onPointerEnter={preloadContactUs}
            onPointerDown={preloadContactUs}
            onFocus={preloadContactUs}
          >
            Contact Us
          </Link>
        </nav>

        <div
          className="hamburger-menu"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <GoX size={32} /> : <GoGrabber size={40} />}
        </div>

        <nav className={`mobile-nav ${mobileMenuOpen ? "show-menu" : ""}`}>
          <div className="mobile-nav-item">
            <a href="#" onClick={(e) => e.preventDefault()}>
              Products
            </a>

            <div className="mobile-dropdown">
              <Link
                to="/whatWeDo/VCheck"
                onPointerDown={preloadProductImages}
                onClick={() => setMobileMenuOpen(false)}
              >
                Vcheck
              </Link>

              <Link
                to="/whatWeDo/Acaia"
                onPointerDown={preloadProductImages}
                onClick={() => setMobileMenuOpen(false)}
              >
                Acaia
              </Link>

              <Link
                to="/whatWeDo/Exaan"
                onPointerDown={preloadProductImages}
                onClick={() => setMobileMenuOpen(false)}
              >
                Exaan
              </Link>

              <Link
                to="/whatWeDo/Enrol"
                onPointerDown={preloadProductImages}
                onClick={() => setMobileMenuOpen(false)}
              >
                Enrol-Admission Software
              </Link>
            </div>
          </div>

          <div className="mobile-nav-item">
            <a href="#" onClick={(e) => e.preventDefault()}>
              Services
            </a>

            <div className="mobile-dropdown">
              <Link
                to="/contactus"
                onPointerDown={preloadContactUs}
                onClick={() => setMobileMenuOpen(false)}
              >
                Software Development
              </Link>

              <Link
                to="/contactus"
                onPointerDown={preloadContactUs}
                onClick={() => setMobileMenuOpen(false)}
              >
                Product & Customer Support
              </Link>

              <Link
                to="/services/web-development"
                onPointerDown={preloadWebDevelopment}
                onClick={() => setMobileMenuOpen(false)}
              >
                Web Development
              </Link>

              <Link
                to="/contactus"
                onPointerDown={preloadContactUs}
                onClick={() => setMobileMenuOpen(false)}
              >
                AI & Data Science
              </Link>

              <Link
                to="/contactus"
                onPointerDown={preloadContactUs}
                onClick={() => setMobileMenuOpen(false)}
              >
                Mobile App Development
              </Link>

              <Link
                to="/contactus"
                onPointerDown={preloadContactUs}
                onClick={() => setMobileMenuOpen(false)}
              >
                Digital Marketing
              </Link>

              <Link
                to="/contactus"
                onPointerDown={preloadContactUs}
                onClick={() => setMobileMenuOpen(false)}
              >
                Resource to hire
              </Link>
            </div>
          </div>

          <Link to="/whoWeAre" onClick={() => setMobileMenuOpen(false)}>
            Who we are
          </Link>

          <Link
            to="/blog"
            onPointerDown={preloadBlog}
            onClick={() => setMobileMenuOpen(false)}
          >
            Insights
          </Link>

          <Link
            to="/careers"
            onPointerDown={preloadCareerImages}
            onClick={() => setMobileMenuOpen(false)}
          >
            Careers
          </Link>

          <Link
            to="/contactus"
            onPointerDown={preloadContactUs}
            onClick={() => setMobileMenuOpen(false)}
          >
            Contact Us
          </Link>
        </nav>
      </header>
    </div>
  );
};

export default Nav;
